document.addEventListener('DOMContentLoaded', function() {
  // Function to loop through all product blocks and update combined variant string
  function updateCombinedVariants() {
    document.querySelectorAll('.product-block').forEach(function(productBlock) {
      let checkedVariants = [];  // Array to store all checked variant titles
      
      // Loop through each option in the product block
      productBlock.querySelectorAll('.option').forEach(function(option) {
        // Find the checked variant for the current option
        let checkedInput = option.querySelector('input[type="radio"]:checked');
        if (checkedInput) {
          checkedVariants.push(checkedInput.value);  // Save the checked variant's value (title)
          
        }
      });

      // Combine the checked variant titles with a '/' separator
      let combinedVariants = checkedVariants.join(' / ');
      // console.log("Combined Variants for Product " + productBlock.getAttribute('data-product-id') + ": " + combinedVariants);

      // Now match the combined variant titles with the select options
      let variantSelect = productBlock.querySelector('.variant-select');
      let variantId = null;

      // Loop through each option in the select element
      variantSelect.querySelectorAll('option').forEach(function(option) {
        if (option.textContent.trim() === combinedVariants.trim()) {
          variantId = option.value; // Get the variant ID if the title matches
        }
      });

      if (variantId) {
        // console.log("Matched Variant ID: " + variantId);
        // Update the hidden input field with the selected variant ID
        let hiddenInput = productBlock.querySelector('.product-variant-id');
        hiddenInput.value = variantId;
      } else {
        // console.log("No matching variant found for: " + combinedVariants);
        // Revert to the first available variant in the select if the variant doesn't exist
        let firstOption = variantSelect.querySelector('option');
        if (firstOption) {
          let firstVariantValue = firstOption.value;
          productBlock.querySelectorAll('.option').forEach(function(option) {
            let firstInput = option.querySelector('input[type="radio"]');
            if (firstInput) {
              firstInput.checked = true;
            }
          });
          // Update the hidden input field with the new selected variant ID
          let hiddenInput = productBlock.querySelector('.selected-variant-id');
          hiddenInput.value = firstVariantValue;          
        }
      }
    });
  }

  // Add event listeners to all radio buttons to detect changes
  document.querySelectorAll('input[type="radio"]').forEach(function(input) {
    input.addEventListener('change', function() {


        let productBlock = input.closest('.product-block');
        
        // Get the label containing the data-image-source for the checked input
        let label = input.closest('label');
        let variantImageSrc = label.getAttribute('data-image-source'); // Get the variant image source from the label
        // console.log("Image Source =>", variantImageSrc);
        // console.log("Product Block =>", productBlock);
        // Update the main product image (assuming it's a child of a sibling of the parent of .product-block)
        let mainProductImage = productBlock.closest('.grand-card').querySelector('.card__inner .card__media .media .main-product-image');
        
        if (mainProductImage && variantImageSrc) {
          mainProductImage.src = variantImageSrc; // Update the image source
          mainProductImage.srcset = variantImageSrc;
        }


      
      // When a variant is selected, update the combined variant string and find the variant ID
      updateCombinedVariants();
    });
  });
});